import React from 'react'
import PropTypes from 'prop-types'

const SectionHeading = ({ priority = 2, text, classes = '' }) => {
	const Tag = `h${priority}`

	return <Tag className={classes}>{text}</Tag>
}

SectionHeading.propTypes = {
	priority: PropTypes.number,
	text: PropTypes.string,
	classes: PropTypes.string
}

export default SectionHeading


// WEBPACK FOOTER //
// ./src/components/Heading.js